import Helper from '@ember/component/helper';
import { ImportState } from 'cio/models/import';

export function importStateGte([currentState, compareState]) {
  if (currentState === ImportState.Failed) {
    return false;
  }

  let states = Object.values(ImportState);
  return states.indexOf(currentState) >= states.indexOf(compareState);
}

export default Helper.helper(importStateGte);
